import React from 'react'
import Nav from 'react-bootstrap/Nav'
import { NavLink } from 'react-router-dom'

export default function HeaderTab({url, text, color, activeColor, isActive}) {
    return (
        <Nav.Link>
            <NavLink to={url} style={{textDecoration:"none"}}>
            {isActive && <span style={{color:activeColor, fontWeight:"bold"}}> {text} </span>}
            {!isActive && <span style={{color:color}}> {text} </span>}
            </NavLink>
        </Nav.Link>
    )
}
